import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import specialties from './profileSpecialties.json'

Vue.use(Vuex)

let getEnvironment = (hostname)=>{
    return hostname.toLowerCase().split('.')[0];
}

export default new Vuex.Store({
    state:{
        branch: 'BETA',
        session_id: false,
        ready: false,
        csrf: false,
        jwt: false,
        user: false,
        // api: process.env.NODE_ENV == 'development' ? "http://vivomap-api.ca/requestHandler.php" : "src/api/requestHandler.php",
        // api: "http://localhost/vue/vivomap.ca/src/api/requestHandler.php",

        // api: process.env.NODE_ENV == 'development' ? "http://"+window.location.hostname+"/vue_prj/vivomap.ca/src/api/requestHandler.php" : "/src/api/requestHandler.php",
        // baseURL: process.env.NODE_ENV == 'development' ? "http://"+window.location.hostname+"/vue_prj/vivomap.ca/" : "../../../",
        // v3_portal_url: process.env.NODE_ENV == 'development' ? "http://"+window.location.hostname+"/vue_prj/vivomap.ca/v3" : window.location.origin+'/v3',
        
        api: process.env.NODE_ENV == 'development' ? "http://"+window.location.hostname+"/src/api/requestHandler.php" : "/src/api/requestHandler.php",
        baseURL: process.env.NODE_ENV == 'development' ? "http://"+window.location.hostname+"/" : "https://"+window.location.hostname + "/",
        v3_portal_url: process.env.NODE_ENV == 'development' ? "http://"+window.location.hostname+"/v3" : window.location.origin+'/v3',
        v4_media_url: process.env.NODE_ENV == 'development' ? "https://qa.vivomap.ca/s3" : window.location.origin+'/s3',
        overlays: {
            login: false,
            programAdmin: false,
            loginRep: false,
            contactUs: false,
            editProfile: false,
            siteRegulation: false,
            accountValidation: false,
            accountValidationError: false,
            programAdminQuickAccess: false
        },
        busy: 0,
        window: {
            width: 0, 
            height: 0
        },
        programs: null,
        programStatus: null,
        language: 'en',
        progressBar: null,
        mode: 'user',
        entryURL: null,
        library: null,
        userSession: {},
        siteRegulationTargetTab: 'overview',
        V3_PortalState: 'closed',
        featuredProgramId: 0,
        environment: getEnvironment(window.location.hostname),
        companyName: "CTC Communications",
        specialties
    },
    mutations,
    actions,
    getters
});